import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { ButtonProps } from '@rtkwlf/fenrir-react';
import { Button, VStack } from '@rtkwlf/fenrir-react';
import { faFileExport } from '@rtkwlf/pro-solid-svg-icons/faFileExport';
import { useTranslation } from 'react-i18next';

import { useDownload } from '@packages/hooks/useDownload';

export type CsvFileData = string | ArrayBuffer | null | undefined;

type CsvExportProps = Omit<ButtonProps, 'onClick'> & {
  data: string;
  fileName?: string;
};

export const CsvExport: React.FC<CsvExportProps> = ({
  data,
  fileName,
  variant = 'link',
  iconLeft = <FontAwesomeIcon icon={faFileExport} />,
  children,
  ...otherProps
}) => {
  const { t } = useTranslation();
  const filename = fileName ?? t('reports:untitledFileName');
  const { download } = useDownload(`${filename}.csv`, data);

  const button = (
    <Button
      variant={variant}
      iconLeft={iconLeft}
      onClick={download}
      {...otherProps}
    >
      {children ?? t('icon:exportText')}
    </Button>
  );

  return variant === 'link' ? (
    <VStack padding="small">{button}</VStack>
  ) : (
    button
  );
};
